import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { reduxForm, formValueSelector } from "redux-form";
import { AddBankDetailsContainer } from "./css";
import { Field } from "redux-form";
import { RenderInput } from "../Common/FormFields";
import { Alert, Button, IconAttention, IconDone } from "@payright/web-components";
import * as CONSTANT from '../../util/constants/messages';

let AddBankDetails = (props) => {
  const { handleSubmit, bankName, bsb, accountNumber, accountName, submitting, submitSucceeded, error, } = props;
  const [showSuccess, setShowSuccess] = useState(false);
  const isFormIncomplete = !bankName || !bsb || !accountNumber || !accountName;

  useEffect(() => {
    if (submitting || error) {
      setShowSuccess(false);
    } else if (submitSucceeded) {
      setShowSuccess(true);
    }
  }, [error, submitting, submitSucceeded]);

  return (
    <div>
      <h3 className="page-title">{"Bank Account Details"}</h3>
      <AddBankDetailsContainer>
        <p className="page-description">{"Use this page to add or update your bank account details so we can deposit any payments owing to you."}</p>
        <div className="alert-section">
        {showSuccess && (
          <Alert
            title={CONSTANT.SUCCESS_ALERT_TITLE}
            body={CONSTANT.BANK_ACCOUNT_DETAILS_UPDATED_MESSAGE}
            outcome="positive"
            icon={<IconDone />}
          />
        )}
        {error && (
          <Alert
            title={CONSTANT.ERROR_ALERT_TITLE}
            body={CONSTANT.BANK_ACCOUNT_DETAILS_UPDATE_FAILED_MESSAGE}
            outcome="error"
            icon={<IconAttention />}
          />
        )}
        </div>
        <form className="addBankDetails" onSubmit={handleSubmit}>
          <Field
            name="bankName"
            label="Bank Name"
            type="text"
            component={RenderInput}
          />
          <Field
            name="bsb"
            label="BSB"
            type="text"
            component={RenderInput}
          />
          <Field
            name="accountNumber"
            label="Account Number"
            type="text"
            component={RenderInput}
          />
          <Field
            name="accountName"
            label="Account Name"
            type="text"
            component={RenderInput}
          />
          <div className="btn-section">
            <Button colour="blue" type="submit" maxWidth="20%" disabled={submitting || isFormIncomplete}>
              { submitting ?
                  <>
                      { CONSTANT.SUBMITTING_TEXT }
                  </>
              :
                  <>
                      { CONSTANT.UPDATE_TEXT }
                  </>
              }
            </Button>
          </div>
        </form>
      </AddBankDetailsContainer>
    </div>
  );
};

AddBankDetails = reduxForm({
  form: "AddBankDetails",
  enableReinitialize: true,
})(AddBankDetails);

const selector = formValueSelector("AddBankDetails");

const mapStateToProps = (state) => {
  const remediationDetails = state.pageData.remediationDetails || {};
  const { isRemediationRequired, ...bankAccountDetails } = remediationDetails;

  return {
    initialValues: bankAccountDetails,
    bankName: selector(state, "bankName"),
    bsb: selector(state, "bsb"),
    accountNumber: selector(state, "accountNumber"),
    accountName: selector(state, "accountName"),
  };
};

export default connect(mapStateToProps)(AddBankDetails);
